<div class="col-md-12">
  <div class="border rounded-2 p-4 kdiv">
    <h3>Advanced Search</h3>
    <br />
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-12">
          Enter beginning and ending Fiscal Year. Leave blank to have open-ended search.
          <br /><br />
        </div>
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Beginning Fiscal Year</mat-label>
            <input matInput type="number" formControlName="beginningFiscalYear" required />

            @if (form.get('beginningFiscalYear')?.hasError('required')) {
              <mat-error>
                Beginning Fiscal Year is required
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Ending Fiscal Year</mat-label>
            <input matInput type="number" formControlName="endingFiscalYear" />
            @if (form.hasError('fiscalYearInvalid') &&form.get('endingFiscalYear')?.touched) {
              <mat-error>
                Ending Fiscal Year must be greater than Beginning Fiscal Year
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-12"><br /></div>
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Field</mat-label>
            <mat-select multiple formControlName="fields" required>
              <mat-option value="name">Name</mat-option>
              <mat-option value="description">Description</mat-option>
              <mat-option value="additionalComments">Additional Comments</mat-option>
              <mat-option value="namc">NAMC</mat-option>
              <mat-option value="shop">Shop</mat-option>
              <mat-option value="line">Line</mat-option>
              <mat-option value="model">Model</mat-option>
              <mat-option value="savingsImpact">
                Saving Impact (By NAMC, By Line, By Shop, By Model)
              </mat-option>
              <mat-option value="tags">Keyword as Tags</mat-option>
              <mat-option value="investmentType">Investment Type</mat-option>
              <mat-option value="account">Account</mat-option>
              <mat-option value="accountDetail">Account Detail</mat-option>
              <mat-option value="savingsMeasure">Savings Measure</mat-option>
              <mat-select-trigger>
                {{ form.get('fields')?.value?.length || 'Select' }} selected
              </mat-select-trigger>
            </mat-select>
            @if (form.get('fields')?.hasError('required')) {
              <mat-error>
                At least one field must be selected
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Enter Criteria</mat-label>
            <input matInput formControlName="criteria" required />
            @if (form.get('criteria')?.hasError('required')) {
              <mat-error>
                Criteria is required
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-12 d-flex mt-3 gap-2">
          <button mat-flat-button color="primary" type="button" [disabled]="form.invalid" (click)="submit()">
            Advanced Search
          </button>
          <button mat-flat-button color="warn" type="button" (click)="resetForm()">
            Reset
          </button>
        </div>
      </div>
    </form>
    @if (submitted) {
      <div class="mt-3">
        <mat-card appearance="outlined">
          <mat-card-content>
            <strong>Search Summary:</strong>
            <br />
            {{ searchSummary }}
          </mat-card-content>
        </mat-card>
      </div>
    }
    @if (loading) {
      <div class="mt-3">
        <mat-progress-spinner diameter="30"></mat-progress-spinner>
      </div>
    }
    @if (submitted && !loading && searchResults.length > 0) {
      <div class="mt-3">
        <mat-table [dataSource]="searchResults" class="table">
          <ng-container matColumnDef="kaizenNumber">
            <mat-header-cell *matHeaderCellDef> KZ NUM# </mat-header-cell>
            <mat-cell *matCellDef="let row"> K{{ row.kaizenNumber }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="company">
            <mat-header-cell *matHeaderCellDef> NAMC </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.company }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="line">
            <mat-header-cell *matHeaderCellDef> Line </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.line }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="shop">
            <mat-header-cell *matHeaderCellDef> Shop </mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.shop?.toString() }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="model">
            <mat-header-cell *matHeaderCellDef> Model </mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.model?.toString() }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="savingsImpact">
            <mat-header-cell *matHeaderCellDef> Saving Impact </mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.savingsImpact?.toString() }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="investmentType">
            <mat-header-cell *matHeaderCellDef> Investment Type </mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.investmentType?.toString() }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.name }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="account">
            <mat-header-cell *matHeaderCellDef> Account </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.account }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="fySavings">
            <mat-header-cell *matHeaderCellDef> Est Yearly Savings </mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.fySavings | currency:'USD':'symbol':'1.0' }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="state">
            <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.state }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
            <mat-cell *matCellDef="let row"> <a style="color: blue;"
            routerLink="/kaizenDetails/{{row.kaizenId}}">Details</a> </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    }
    @if (submitted && searchResults.length === 0) {
      <div class="mt-3">
        <mat-card>
          <mat-card-content>
            No results found matching your search criteria.
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>
</div>